import { cryptoWaitReady } from "@polkadot/util-crypto";
let loadingPromise;
export function loadPolkadotCrypto() {
    if (loadingPromise)
        return loadingPromise;
    const p = cryptoWaitReady();
    loadingPromise = p;
    return p;
}
//# sourceMappingURL=polkadot-crypto.js.map